import { useMemo } from 'react'
import type { Collection, Node } from '@react-types/shared'
import { Key, ListKeyboardDelegate, useCollator } from 'react-aria'
import { DynamicCascadeItem, DynamicItem } from '../base-select/dynamicItemUtils'

export const useSelectListKeyboardDelegate = (
  collection: Collection<Node<DynamicItem>>,
  disabledKeys: Set<Key>,
  includeCascadeItems = false
) => {
  const collator = useCollator({ usage: 'search', sensitivity: 'base' })

  return useMemo(() => {
    if (includeCascadeItems) {
      return new ListKeyboardDelegate(collection, disabledKeys, { current: null }, collator)
    }
    const disabledAndCascadeKeys = new Set([
      ...disabledKeys,
      ...[...collection]
        .map(i => i.value)
        .filter((i): i is DynamicCascadeItem => i?.itemType === 'cascade')
        .map(i => i.value),
    ])
    return new ListKeyboardDelegate(collection, disabledAndCascadeKeys, { current: null }, collator)
  }, [collection, disabledKeys, collator, includeCascadeItems])
}
